import { LOGIN, SET_PERMISSION_PENDING, ENABLE_DARK_SIDE } from './mutation-types'
import * as fakeFirebaseUser from './fakeFirebaseUser'

const loginAttempt = async ({ username, password }) =>
  new Promise(async resolve => {
    if (username.toLowerCase() === 'c117') { // ep1-4
      if (password.toLowerCase() === 'viralgenome') { // ep1
        fakeFirebaseUser.email = 'c117@episode1.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'motherboard') { // ep2 unencrypted
        fakeFirebaseUser.email = 'c117@episode2.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'qsxlivfsevh') { // ep2 encrypted
        fakeFirebaseUser.email = 'c117-encrypted@episode2.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'jonassalk') { // ep3 unencrypted
        fakeFirebaseUser.email = 'c117@episode3.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'tyxkcckvu') { // ep3 encrypted
        fakeFirebaseUser.email = 'c117-encrypted@episode3.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'transversewave') { // ep4 unencrypted
        fakeFirebaseUser.email = 'c117@episode4.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'fdmzehqdeqimhq') { // ep4 encrypted
        fakeFirebaseUser.email = 'c117-encrypted@episode4.com'
        resolve(fakeFirebaseUser)
      }
    } else if (username.toLowerCase() === 'a117') {
      if (password.toLowerCase() === 'alanturing') { // ep5 unencrypted
        fakeFirebaseUser.email = 'a117@episode5.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'fqfsyzwnsl') { // ep5 encrypted
        fakeFirebaseUser.email = 'a117-encrypted@episode5.com'
        resolve(fakeFirebaseUser)
      }
    } else if (username.toLowerCase() === 'backdoor') { // <-- confirmed username
      if (password.toLowerCase() === 'atg123') { // ep2 alosha's data cache
        fakeFirebaseUser.email = 'backdoor@episode2.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'fortythieves123') { // ep3 unencrypted
        fakeFirebaseUser.email = 'backdoor@episode3.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'th1r7y51x123') { // ep3 unencrypted
        fakeFirebaseUser.email = 'backdoor@episode4.com'
        resolve(fakeFirebaseUser)
      } else if (password.toLowerCase() === 'derrida51123') { // ep3 unencrypted
        fakeFirebaseUser.email = 'backdoor@episode5.com'
        resolve(fakeFirebaseUser)
      }
    } else if (username.toLowerCase() === 'backdoor-terminal') {
      if (password.toLowerCase() === 'perigee') {
        fakeFirebaseUser.email = 'backdoor-terminal@episode4.com'
        resolve(fakeFirebaseUser)
      }
    } else {
      resolve(false)
    }
  })

export default {
  checkUser: async ({ commit }, { username, password }) =>
    new Promise(async resolve => {
      if (username.toLowerCase() === 'room105a@episode3.com') { // <-- confirmed username
        if (password.toLowerCase() === 'room1439') {
          fakeFirebaseUser.email = 'room105a@episode3.com'
          resolve(fakeFirebaseUser)
        } else {
          throw new Error()
        }
      } else if (username.toLowerCase() === 'councilportal@episode5.com') { // backdoor
        if (password.toLowerCase() === 'yesterday') { // ep2 unencrypted
          fakeFirebaseUser.email = 'councilportal@episode5.com'
          resolve(fakeFirebaseUser)
        } else {
          throw new Error()
        }
      } else if (username.toLowerCase() === 'failsafe@episode5.com') {
        if (password.toLowerCase() === 'apogee') {
          fakeFirebaseUser.email = 'failsafe@episode5.com'
          resolve(fakeFirebaseUser)
        } else {
          throw new Error()
        }
      } else {
        throw new Error()
      }
    }),

  loginUser: async ({ commit }, { username, password, backdoor }) => {
    let user = await loginAttempt({ username, password })

    if (!user && !backdoor) {
      user = await loginAttempt({
        username: `${username}-encrypted`,
        password,
      })
    }

    if (!user) {
      throw new Error()
    }

    if (!backdoor) {
      return commit(LOGIN, user)
    }
  },

  showPermissionPending: ({ commit, dispatch, state }) => {
    commit(SET_PERMISSION_PENDING, true)
    if (state.dark) {
      return
    }
    setTimeout(() => {
      dispatch('hidePermissionPending')
    }, 3000)
  },

  hidePermissionPending: ({ commit }) => {
    commit(SET_PERMISSION_PENDING, false)
  },

  enableDarkSide: ({ commit }) => {
    commit(ENABLE_DARK_SIDE)
  },
}
